import { DynFormSectionBase } from "../dyn-form-section.model"


export class DynFormSectionResponseBase {

    ok: boolean = true
    messageCode: string = ""
    entity: DynFormSectionBase = new DynFormSectionBase()

    static from(dfs: DynFormSectionResponse): DynFormSectionResponseBase {
        let current = new DynFormSectionResponseBase()
        Object.assign(current, dfs)

        if (dfs.entity) {
            current.entity = DynFormSectionBase.from(dfs.entity)
        }

        return current
    }

}

export interface DynFormSectionResponse extends DynFormSectionResponseBase { }